<template>
    <div class="flats-items-compare-container" v-if="flatsArr != null">
        <div class="flat-cards-items-list-info">
            <ul>
                <div class="left">
                    <li><p>{{flatsPage.flats_cards_info.flat_plan_name}}</p></li>
                </div>
                <div class="center">
                    <li><p>{{flatsPage.flats_cards_info.flat_object_name}}</p></li>
                    <li><p>{{flatsPage.flats_cards_info.flat_rooms}}</p></li>
                    <li><p>{{flatsPage.flats_cards_info.flat_size}}</p></li>
                    <li><p>{{flatsPage.flats_cards_info.flat_price}} </p></li>
                    <li><p>{{flatsPage.flats_cards_info.flat_floor}}</p></li>
                    <li><p>{{flatsPage.flats_cards_info.flat_flat_number}}</p></li>
                    <li><p>{{flatsPage.flats_cards_info.flat_bloom}}</p></li>
                </div>
                <div class="right">
                    <li><p>{{flatsPage.flats_cards_info.flat_you_can_name}}</p></li>
                </div>
            </ul>
        </div>
        <!-- {{ flatsArr }} -->
        <div class="flats-items-compare" v-if="!isMobileChecker">
            <div class="flat-item" v-for="item in flatsArr" :key="item.id">
                <router-link :to="{ name: 'flat-crm-card' , params:{'id' : item.id}}" class="item-link" @click.native="startLoader">
                    <div class="mobile-project" v-if="isMobileChecker">
                        <p v-if="isMobileChecker">Объект</p>
                        <div class="project" v-if="item.complexCode != 'LDM'">
                            {{item.complexName.replace(/['"]+/g, '')}}
                        </div>
                        <div class="project" v-else>
                            {{item.complexName.replace(/\,.*/,'')}}
                        </div>
                    </div>
                    <div class="item-default item-img" v-if="item != null && item.id != null">
                        <div class="img-in" v-if="item.images.length > 0">
                            <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pic.id" v-for="(pic, index) in item.images.filter(item => item.typeCode === '1')" :key="index">
                        </div>
                    </div>
                    <div class="item-info">
                        <ul>
                            <li v-if="!isMobileChecker">
                                <!-- {{item.complexName.replace(/['"]+/g, '')}} -->
                                <div class="project" v-if="item.complexCode != 'LDM' && item.complexCode != 'LDM-II' && item.complexCode != 'LDM-III' && item.complexCode != 'LDM-IV'">
                                    {{item.complexName.replace(/['"]+/g, '')}}
                                </div>
                                <div class="project" v-else>
                                    {{item.complexName.replace(/\,.*/,'')}}
                                </div>
                                <p v-if="isMobileChecker">{{flatsPage.flats_cards_info.flat_object_name}}</p>
                            </li>
                             <li>
                                {{item.rooms}}
                                <p v-if="isMobileChecker">{{flatsPage.flats_cards_info.flat_rooms}}</p>
                            </li>
                            <li>
                                {{item.area}} <span>м²</span>
                                <p v-if="isMobileChecker">{{flatsPage.flats_cards_info.flat_size}}</p>
                            </li>
                            <li class="price">
                                <strong v-if="item.showPricesOnSaleSite == true"><span>от</span> {{getNumber(item.meterPrice)}} <span v-if="!isMobileChecker">тг. м²</span></strong>
                                <strong><span>от</span> {{ getNumber(item.totalPrice) }} <span v-if="!isMobileChecker">млн. тг.</span></strong>
                                <p v-if="isMobileChecker">{{ flatsPage.flats_cards_info.flat_price }}<span>тг. м²</span></p>
                            </li>
                            <li>
                                {{item.floor}}
                                <p v-if="isMobileChecker">{{flatsPage.flats_cards_info.flat_floor}}</p>
                            </li>
                            <li>
                                {{item.number}}
                                <p v-if="isMobileChecker">{{flatsPage.flats_cards_info.flat_flat_number}}</p>
                            </li>
                            <li>
                                <!-- {{getNumbersOfString(item.blockName)}} -->
                                <div class="right" v-if="item.complexCode != 'DSV' && item.complexCode != 'LDM' && item.complexCode != 'LDM-II' && item.complexCode != 'LDM-III' && item.complexCode != 'LDM-IV' && item.complexCode != 'SOH' && item.complexCode != 'MNC'">
                                    {{getNumbersOfString(item.blockName)}}
                                </div>
                                <div class="right" v-if="item.complexCode == 'DSV' || item.complexCode == 'LDM' || item.complexCode == 'LDM-II' || item.complexCode == 'LDM-III' || item.complexCode == 'LDM-IV'">
                                    {{getNumbersOfBlockDiscovery(item.blockName)}}
                                </div>
                                <div class="right" v-if="item.complexCode == 'MNC'">
                                    {{ getNumbersOfBlockMonaco(item.blockName) }}
                                </div>
                                <div class="blockname" v-if="item.complexCode == 'SOH'">
                                    {{getNumbersOfBlockSoho(item.blockName)}}
                                </div>
                                <p v-if="isMobileChecker && item.complexCode != 'SOH'">{{flatsPage.flats_cards_info.flat_bloom}}</p>
                                <p v-if="isMobileChecker && item.complexCode == 'SOH'">{{flatsPage.flats_cards_info.flat_kvartal}}</p>
                            </li>
                        </ul>
                    </div>
                    <!-- <div class="item-btns">
                        <a 
                            :href="URLrocketLC + '/?apartment_id=' + item.id +'&method=book&lang=' + langVAR" class="bron" target="_blank" 
                            @click.prevent="linkToLogin(URLrocketLC + '/?apartment_id=' + item.id +'&method=book&lang=' + langVAR, 'book')"
                            v-if="item.isApartmentReserved"
                            >{{flatsPage.flats_cards_info.flat_btn_book_name}}
                        </a>
                        <span v-else class="btn-off bron-off">{{flatsPage.flats_cards_info.flat_btn_book_name}}</span>
                        <a 
                            :href="URLrocketLC + '/?apartment_id=' + item.id +'&method=by&lang=' + langVAR" class="by" target="_blank" 
                            @click.prevent="linkToLogin(URLrocketLC + '/?apartment_id=' + item.id +'&method=by&lang=' + langVAR, 'by')" 
                            v-if="item.hasJointVentureAgreement"
                            >{{flatsPage.flats_cards_info.flat_btn_by_name}}
                        </a>
                        <span v-else class="btn-off by-off">{{flatsPage.flats_cards_info.flat_btn_by_name}}</span>
                    </div> -->
                </router-link>
                <!-- <div class="btn-to-favorite">
                    <a href="#" class="favorite-link" @click.prevent="sendToFavorite(item.id), checkerClass($event)" :class="{'active' : checkProjectFavorite(item.id)}">
                        <svgIcon name="star" class="icon-star"/>
                    </a>
                </div> -->
            </div>
        </div>

        <div class="flats-items-compare-mobile" v-else>
            <div class="flat-item" v-for="item in flatsArr" :key="item.id">
                <router-link :to="{ name: 'flat-crm-card' , params:{'id' : item.id}}" class="item-link" @click.native="startLoader">
                    <div class="flat-item-head">
                        <div class="info-list-main">
                            <ul>
                                <li class="object-name">
                                    <strong v-if="item.complexCode != 'LDM' && item.complexCode != 'LDM-II' && item.complexCode != 'LDM-III' && item.complexCode != 'LDM-IV'">{{item.complexName.replace(/['"]+/g, '')}}</strong>
                                    <strong v-else>{{item.complexName.replace(/\,.*/,'')}}</strong>
                                </li>
                                <li>
                                    <strong>{{item.rooms}} <span>комнатная</span>,</strong>
                                    <p> {{item.area}} <span>м²</span></p>
                                </li>
                            </ul>
                        </div>
                        <div class="info-list-small">
                            <ul>
                                <li class="small">
                                    <span v-if="item.complexCode != 'SOH'">{{flatsPage.flats_cards_info.flat_bloom}}</span>
                                    <span v-else>{{flatsPage.flats_cards_info.flat_kvartal}}</span>
                                    <p v-if="item.complexCode != 'DSV' && item.complexCode != 'LDM' && item.complexCode != 'LDM-II' && item.complexCode != 'LDM-III' && item.complexCode != 'LDM-IV' && item.complexCode != 'SOH'">{{getNumbersOfString(item.blockName)}},</p>
                                    <p v-if="item.complexCode == 'DSV' || item.complexCode == 'LDM' || item.complexCode == 'LDM-II' || item.complexCode == 'LDM-III' || item.complexCode == 'LDM-IV'">{{getNumbersOfBlockDiscovery(item.blockName)}},</p>
                                    <p v-if="item.complexCode == 'SOH'">{{getNumbersOfBlockSoho(item.blockName)}},</p>
                                </li>
                                <li>
                                    <span>{{flatsPage.flats_cards_info.flat_floor}}</span>
                                    <p>{{item.floor}},</p>
                                </li>
                                <li>
                                    <span>{{flatsPage.flats_cards_info.flat_flat_number}}</span>
                                    <p>{{item.number}}</p>
                                </li>
                            </ul>
                        </div>
                        <div class="item-default item-img" v-if="item != null && item.id != null">
                            <div class="img-in" v-if="item.images.length > 0">
                                <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pic.id" v-for="(pic, index) in item.images.filter(item => item.typeCode === '1')" :key="index">
                            </div>
                        </div>
                    </div>
                    <div class="price-info">
                        <ul>
                            <li>
                                <strong>{{flatsPage.flats_cards_info.flat_full_price}}</strong>
                                <p v-if="item.showPricesOnSaleSite == true"><span>от</span> {{getNumber(item.totalPrice)}} <span>млн. тг.</span></p>
                            </li>
                            <li>
                                <strong>{{ flatsPage.flats_cards_info.flat_price }} за м²</strong>
                                <p v-if="item.showPricesOnSaleSite == true"><span>от</span> {{getNumber(item.meterPrice)}} <span>тыс. тг</span></p>
                            </li>
                        </ul>
                    </div>
                </router-link>
                <div class="item-btns">
                    <router-link :to="{ name: 'flat-crm-card' , params:{'id' : item.id}}" class="item-link" @click.native="startLoader">Выбрать</router-link>
                    <a href="#" class="remove-link" @click.prevent="sendToCompare(item.id), checkerClass($event)">
                        <svgIcon name="close" class="icon-close"/>
                    </a>
                </div>
                <!-- <div class="btn-to-favorite">
                    <a href="#" class="favorite-link" @click.prevent="sendToFavorite(item.id), checkerClass($event)" :class="{'active' : checkProjectFavorite(item.id)}">
                        <svgIcon name="star" class="icon-star"/>
                    </a>
                </div> -->
            </div>
        </div>      
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'flats-item',
        props: ['flatsArr'],
        components: {
            svgIcon,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            flatsPage: 'loadFlatsPage',
            flatsItems: 'loadFlatsItems',
            flatsEmptyMsg: 'loadFlatsEmptyMsg',
            ucoCRMurl: 'loadUrlCRMuco',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            getNumbersOfString(str) {
                return str.replace(/[^0-9]+/g, "");
            },
            getNumbersOfBlockDiscovery(str) { 
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '');
            },
            getNumbersOfBlockLandmark(str) {
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '');
            },
            getNumbersOfBlockSoho(str) {
                var parseStr = str.split(',')[0];
                return parseStr.replace('Квартал', '').replace(/ /g, '');
            },
            getNumbersOfBlockMonaco(str) {
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '').replace(/ /g, '');
            },
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
            },
            startLoader() {
                // this.$parent.$parent.$refs.topProgress.start();
            },
            sendToCompare(id) { // Добавление квартиры в сравнение
                var exist = localStorage.getItem('sales_compare_flats');
                exist = exist ? exist.split(',') : [];
                var finder = exist.find(item => item == id);
                if (finder == undefined) {
                    exist.push(id);
                    localStorage.setItem('sales_compare_flats', exist);
                } else {
                    var filterExist = exist.filter(item => {
                        return item != id
                    })
                    localStorage.setItem('sales_compare_flats', filterExist);
                    window.location.reload();
                }
            },
            checkerClass(event) {
                event.currentTarget.classList.toggle('active');
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            // console.log(this.flatsArr)
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-items-compare.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-items-compare-respond.scss';
    // @import '@/styles/components/flats-crm/flats-crm-items-main.scss';
    // @import '@/styles/components/flats-crm/respond/flats-crm-items-respond.scss';
    // @import '@/styles/components/flats-crm/respond/flats-crm-items-main-respond.scss';
    // @import '@/styles/components/flats-page/respond/flats-item-respond.scss';
</style>